import { PaginationState } from '@tanstack/react-table';

import {
  AiresFilesTableColumns,
  PfcMappingColumns,
  ShareLoanColumns,
  SubmissionStatus,
  UploadHistoryTableColumns,
} from '@/types';

export * from './queryKeys';
export * from './apiBaseUrl';
export * from './apiRoutes';
export * from './providers';
export * from './storageKeys';
export * from './tutorial';
export * from './uiStatusTypes';

export const osType = {
  win: 'Windows',
  mac: 'Mac',
};

export const LEAGUE_KEY = 512;
export const DEFAULT_TOAST_ERROR_TITLE = 'Something went wrong';
export const DEFAULT_TOAST_ERROR_MESSAGE =
  'Please, try again. If the error persists, call your Account Management representative.';
export const DATA_PREPARER_UPLOAD_TOOLTIP =
  "Data Preparer is a desktop application which will secure your members' data by removing sensitive information such as Social Security number and account number from AIRES files";
export const DATA_PREPARER_UPLOAD_DATE =
  'Document Date is the date that the data within a file refers to, e.g., if an AIRES file lists loan (or share) accounts as of December 31, 2021, its document date would be 12/31/2021.';
export const REQUIRED_FIELD = 'This field is required';
export const OLD_DATA_PREPARER_VERSION_RESPONSE =
  'The file(s) was prepared with an outdated version of the Data Preparer. Please download the new version of the app, prepare the files and upload them.';
export const INVALID_DATE_TIME_FORMAT = `DateTime should be in format 'MM/dd/yyyy HH:mm:ss', A value for the 'DocumentDate' parameter or property was not provided.`;
export const INVALID_DATE_MESSAGE = `Document Date should be in the format 'MM/DD/YYYY'`;
export const INVALID_DATE_NONEXISTENT = 'Invalid date. Nonexistent date';
export const LOAN_MAPPING_TOOLTIP =
  'Loan Type Map File - the mapping schema between your credit union’s and NCUA’s loan type codes (you provided  “the map file” to NCUA along with the AIRES loan data files)';
export const SHARE_MAPPING_TOOLTIP =
  'Share Type Map File - the mapping schema between your credit union’s and NCUA’s share type codes (you provided  “the map file” to NCUA along with the AIRES share data files)';
export const PFC_MAPPING_TOOLTIP =
  'Payment Frequency Code - identifier used to specify how often payments are required on loans. Common frequencies include: weekly, twice per month, monthly, quarterly, etc.';

export const DataManagementCrumbs = [
  { name: 'Home', path: '/home' },
  { name: 'Data Management', path: '/' },
];
export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_PAGINATION_STATE: PaginationState = {
  pageIndex: 1,
  pageSize: DEFAULT_PAGE_SIZE,
};
export const DEFAULT_AIRES_SORTING = [
  {
    id: AiresFilesTableColumns.documentDate,
    desc: true,
  },
];
export const DEFAULT_MAPPING_SORTING = [
  {
    id: ShareLoanColumns.typeCode,
    desc: false,
  },
];
export const DEFAULT_PFC_MAPPING_SORTING = [
  {
    id: PfcMappingColumns.pfc,
    desc: false,
  },
];
export const DEFAULT_UPLOAD_HISTORY_SORTING = [
  {
    id: UploadHistoryTableColumns.submissionDate,
    desc: true,
  },
];
export const UPLOAD_MODAL_MAX_FILE_NAME_LENGTH = 24;
export const REFETCH_SUBMISSIONS_STATUSES = [
  SubmissionStatus.Pending,
  SubmissionStatus.InProgress,
  SubmissionStatus.Deleting,
];
export const DEFAULT_MAPPING_ITEMS_PER_PAGE = 10;
export const DEFAULT_MAPPING_EDIT_ITEMS_PER_PAGE = 1000;

export const SYSTEM_ROLE_NAMES = {
  ADMINISTRATORS: 'Administrators',
  FORUM_MODERATORS: 'ForumModerators',
  REGISTERED: 'Registered',
  GUESTS: 'Guests',
  VENDORS: 'Vendors',
  REVIEWERS: 'FOMReviewer',
} as const;
